import { UnifiedActivity } from '@square/dashboard-protos/models/squareup/bizbank/unified_activity';
import Money from '@square/dashboard-money/models/money';
export const UNIFIED_ACTIVITY_STRIKETHROUGH_STATES = [UnifiedActivity.ActivityState.DECLINED, UnifiedActivity.ActivityState.VOIDED];
export const UNIFIED_ACTIVITY_CARD_SPEND_TYPES = [UnifiedActivity.ActivityType.CARD_PAYMENT, UnifiedActivity.ActivityType.ATM_WITHDRAWAL];
const MICROSECONDS_PER_MILLISECOND = 1000;
function usecToMillisec(latestEventAt) {
  if (!latestEventAt) {
    return 0;
  }
  return Math.round(latestEventAt.instantUsec / MICROSECONDS_PER_MILLISECOND);
}
export function getDate(latestEventAt, localeTime) {
  return localeTime.dateTime(usecToMillisec(latestEventAt), 'dateYearLast');
}
export function getAmount(amount, activityState) {
  if (!amount) {
    return null;
  }
  const amountUnsigned = Money.fromProto(amount).unsigned.get('formatted');
  if (UNIFIED_ACTIVITY_STRIKETHROUGH_STATES.includes(activityState) || amount.amount === 0) {
    return amountUnsigned;
  } else if (amount.amount >= 0) {
    return `+ ${amountUnsigned}`;
  } else {
    return `– ${amountUnsigned}`;
  }
}